import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
	getButton,
	hideLoginModal
} from '../../actions/actionsButtonFactory';
import { withRouter, NavLink } from 'react-router-dom';
import _get from 'lodash/get';
import _includes from 'lodash/includes';
import ButtonHTML from './ButtonHTML';
import ButtonURL from './ButtonURL';
import ButtonQRCode from './ButtonQRCode';
import getLocaleMessages from '../../utils/localesMessages';
import * as spinnerUtils from '../../utils/spinnerUtils';
import { AUTH_STATE_ANONYMOUS } from '../../clientConstants';
import { LeaveModal } from '../modals/LeaveModal';
import { trackWizardDetailsPage } from '../../utils/ButtonFactoryFPT';

import _isEmpty from 'lodash/isEmpty';

const {
	header,
	tabHTML,
	tabURL,
	tabQRCode,
	editButton,
	makeAnotherButton,
	duplicateButton,
	savedButtons
} = getLocaleMessages('buttons/buttonCompleteDetails')

const {
	note
} = getLocaleMessages('buttons/leaveModal')

const mapStateToProps = (state) => {
	const { buttonFactory } = state;

	return {
		buttonFactory,
		application: state.application
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		getButton,
		hideLoginModal
	}, dispatch);
}

const NavTab = (props) => {
	return (
		<div
			className={`nav-tab ${props.currentTab === props.activeTab ? 'active' : ''}`}
			onClick={props.switchTab}
			id={props.id}
		>
			<span>{props.tag}</span>
		</div>
	)
}

NavTab.propTypes = {
	currentTab: PropTypes.string,
	activeTab: PropTypes.string,
	tag: PropTypes.string,
	switchTab: PropTypes.func,
	id: PropTypes.string
}

export class ButtonDetails extends Component {
	static propTypes = {
		getButton: PropTypes.func,
		buttonFactory: PropTypes.object,
		application: PropTypes.object,
		history: PropTypes.object,
		hideLoginModal: PropTypes.func
	}

	constructor(props) {
		super(props);

		this.state = {
			activeTab: 'buttonHTML'
		}
	}

	componentDidMount() {
		const { button } = this.props.buttonFactory;
		const isLoggedIn = this.getApplicationValues('authState') !== AUTH_STATE_ANONYMOUS;
		const isHosted = _includes(['BUSINESS', 'PREMIER'], this.getApplicationValues('userType'));

		if (!isHosted) {
			this.showAlertOnRedirect();
		}

		if (!button) {
			const buttonId = _get(this.props, 'match.params.buttonId');
			if (buttonId) {
				if (buttonId === 'unhosted') {
					// User refreshed on button details page
					this.redirectToHomePage();
					return;
				}
				if (isLoggedIn) {
					this.props.getButton(buttonId)
						.always(() => {
							spinnerUtils.hideSpinner();
						})
				} else {
					this.forceUserLogin();
				}
			}
		}

		// Track details page
		trackWizardDetailsPage({
			tab: 'buttonHTML' // Default tab
		});
	}

	componentWillUnmount() {
		window.onbeforeunload = null;
	}

	showAlertOnRedirect() {
		window.onbeforeunload = function(event) {
			// This text doesn't mean anything, browser will have it's own alert message
			// in the dialog for security concern
			return note;
		};

		// don't block user from login
		var loginButton = document.getElementById('ul-btn');
		if (loginButton) {
			loginButton.onclick = function () {
				window.onbeforeunload = null;
			};
		}
	}

	forceUserLogin() {
		const current_location = window.location.href;
		const returnUri = current_location.substr(current_location.indexOf('/buttons'));
		const renderURL = '/donate/buttons/login?returnUri=' + returnUri;
		this.props.history.push(renderURL);
		location.reload();
		this.props.hideLoginModal();
	}

	redirectToHomePage = () => {
		window.location.href = '/donate/buttons';
	}

	getApplicationValues = (key) => {
		return _get(this.props.application, key);
	}

	handleSwitchTab(tab) {
		this.setState({
			activeTab: tab
		})
		// Track details page
		trackWizardDetailsPage({
			tab
		});
	}

	renderTabSubpage(button) {
		switch (this.state.activeTab) {
			case 'buttonHTML':
				return (
					<ButtonHTML button={button} />
				)

			case 'shareableURL':
				return (
					<ButtonURL button={button} />
				)

			case 'QRCode':
				return (
					<ButtonQRCode button={button} isMobile={this.props.application.isMobile}/>
				)

			default:
				return null;
		}
	}

	goToSavedButtons = (event) => {
		spinnerUtils.showSpinner();
		event.preventDefault();
		this.props.history.push('/cgi-bin/webscr?cmd=_button-management');
		location.reload();
	}

	render() {
		const { button, error } = this.props.buttonFactory;
		const buttonId = _get(this.props, 'match.params.buttonId');

		if (!_isEmpty(error)) {
			// This occurs when an invalid buttonId is found
			// Go back to main page
			this.redirectToHomePage();
			return null;
		}

		return (
			<div className="button-detail-container">
				<div className="button-detail-wrapper">
					<div className="button-detail-header">{header}</div>

					<div className="nav-tab-header">
						<NavTab
							tag={tabHTML}
							currentTab="buttonHTML"
							switchTab={() => this.handleSwitchTab('buttonHTML')}
							activeTab={this.state.activeTab}
							id="buttonHTML"
							/>
						<NavTab
							tag={tabURL}
							currentTab="shareableURL"
							switchTab={() => this.handleSwitchTab('shareableURL')}
							activeTab={this.state.activeTab}
							id="shareableURL"
							/>
						<NavTab
							tag={tabQRCode}
							currentTab="QRCode"
							switchTab={() => this.handleSwitchTab('QRCode')}
							activeTab={this.state.activeTab}
							id="QRCode"
							/>
					</div>

					<hr className="vx_hr button-detail-hr" />

					{this.renderTabSubpage(button)}

					<hr className="vx_hr-alt button-detail-hr-alt" />

					{
						buttonId && buttonId === 'unhosted' ?
						<div className="options">
							<NavLink to={`/donate/buttons/${buttonId}/edit`} className="edit-button unhosted">{editButton}</NavLink>
							<NavLink to="/donate/buttons" className="make-another-button unhosted">{makeAnotherButton}</NavLink>
						</div> :

						<div className="options">
							<NavLink to={`/donate/buttons/${buttonId}/edit`} className="edit-button">{editButton}</NavLink>
							<NavLink to={`/donate/buttons/${buttonId}/duplicate`} className="duplicate-button">{duplicateButton}</NavLink>
							<NavLink to="/cgi-bin/webscr?cmd=_button-management" className="saved-buttons" onClick={this.goToSavedButtons}>{savedButtons}</NavLink>
						</div>
					}

					<LeaveModal />
				</div>
		 </div>
		)
	}
}


const ButtonDetailsComponent = connect(mapStateToProps, mapDispatchToProps)(ButtonDetails)
export default withRouter(ButtonDetailsComponent);



// WEBPACK FOOTER //
// ./buttons/components/buttonDetails/ButtonDetails.js